/**
 * author : Ryan Liu yanfang.liu@asiainnovations.com
 * date   : 23 Oct 2018
 * desc   : User Profile Service
 **/
import PbAjax from "up-pbajax";

import publicpb from "../global/publicpb";
import profilepb from "./profile.pb";
import cache from "../global/cache";
import url from 'c-url';

let pbajax = new PbAjax();

function fetchProfile(vuid, userToken) {
    let self = this;
    let feature = url.query('feature') || 0;
    let reqData = new profilepb.Profile.Get.Request({ vuid });
    let defer = $.Deferred();
    let ua =  `H5/h5 version/${getProjectVersion()} feature/${feature}` + window.navigator.userAgent ;

    pbajax.do(
        {
            service: "account",
            api: "/profile/get",
            header: {
                userToken,
                UserAgent: ua
            },
        },
        reqData,
        function (res) {
            let dataWrap = publicpb.Result.decode(res);
            let data;

            if (dataWrap.code == 1) {
                data = profilepb.Profile.Get.Response.decode(
                    dataWrap.data.value
                );
                defer.resolve(data.profile);
            } else {
                defer.reject(dataWrap.msg);
            }
        },
        (err) => {
            defer.reject(err);
        },
        (err) => {
            defer.reject(err);
        }
    );

    return defer.promise();
}

function getProjectVersion() {
    const version = PROJECT_VERSION.split('.')
    version.splice(2, 0, '0')
    return version.join('.')
  }
export default {
    fetchProfile,
};



// WEBPACK FOOTER //
// ./js/process/profile.service.js